import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const BreadcrumbContainer = styled(Breadcrumbs)`
  margin-bottom: 27px !important;
  display: flex;
  align-items: center;
`;

export const BreadcrumbItem = styled(Link)`
  font-family: "Montserrat";
  font-weight: ${({ active }) => (active ? "600" : "400")};
  /* font-weight: 400; */
  font-size: 14px;
  /* line-height: 28px; */
  /* color: ${({ active }) => (active ? "#4A3AFF" : "#4a4a4a")}; */
  color: ${({ active }) => (active ? "#231A3D" : "#4A4A4A")};
  text-decoration: none;
  /* border: 1px dashed black; */
  display: flex;
  align-items: center;
`;

export const InactiveBreadcrumbItem = styled.span`
  font-family: "Montserrat";
  font-weight: ${({ active }) => (active ? "600" : "400")};
  /* font-weight: 400; */
  font-size: 14px;
  /* color: ${({ active }) => (active ? "#4A3AFF" : "#4a4a4a")}; */
  color: ${({ active }) => (active ? "#231A3D" : "#4A4A4A")};
  /* border: 1px dashed black; */
  display: flex;
  align-items: center;
`;
